import CategoriesView from "@/category/CategoriesView";

export default [
    {
        path: '/categories',
        name: 'Categories',
        component: CategoriesView
    },
];
